import {LOAD_PACKAGE_LIST_BEGIN, LOAD_PACKAGE_LIST_FAILURE, LOAD_PACKAGE_LIST_SUCCESS} from "../actions/PackageListActions";

const initialState = {
    loading: true,
    packageList: []
}

/**
 * Reducer function for PackageList View that changes state
 * based on the action triggered.
 */
export default function packageListReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_PACKAGE_LIST_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_PACKAGE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                packageList: action.packageList
            };
        case LOAD_PACKAGE_LIST_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/PackageListReducer.js